<template>
  <div>
    <span @click.prevent="signOut">Log out</span>
  </div>
</template>

<script>
import Firebase from 'firebase'
import { store } from '../store/store.js'

Firebase.auth().onAuthStateChanged(function(user) {
  if(user) {
    store.dispatch('setUser', user)
  } else {
    store.dispatch('setUser', null)
  }
});

export default {
  methods: {
    signOut() {
      Firebase.auth().signOut().then(function() {
        alert('logged out');
      }).catch(function(error) {
        alert('error.');
      })
    }
  },
  computed: {
    currentUser(){
      return this.$store.getters.currentUser
    }
  }
}

</script>


// WEBPACK FOOTER //
// src/components/Logout.vue